export const CREATE_PROTRACK_FORM_NAME = 'createProtrack'
export const EDIT_PROTRACK_FORM_NAME = 'editProtrack'
export const CLONE_PROTRACK_MODAL_FORM = 'cloneProtrackModalForm'
